module.exports = __webpack_public_path__ + "img/zuijia_30.86d49e2c.png";